import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import {
    CanActivate, ActivatedRoute, ActivatedRouteSnapshot,
    RouterStateSnapshot, CanActivateChild, CanLoad, Route, Router
} from '@angular/router';
import { AuthorizeService  } from '../services/auth/authorize.service';
import { AuthService } from '../services';

@Injectable()
export class RoleGuard implements CanActivate, CanActivateChild, CanLoad {

    constructor(private authorizeService: AuthorizeService , private authService: AuthService, private router: Router) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const user = this.authService.currentUser;
        const isRoleAssigned: boolean = user.roles.includes(route.data.role);
        if (this.authorizeService.isAuthenticated && isRoleAssigned) {
            return true;
        }
        this.router.navigate([environment.loginUrl]);
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    canLoad(route: Route): boolean {

        const url = `/${route.path}`;
        return this.checkLogin(url);
    }

    checkLogin(url: string): boolean {

        if (this.authorizeService.isAuthenticated) {
            return true;
        }
        this.router.navigate([environment.loginUrl]);
        return false;
    }
}
